import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuthContext } from '@/contexts/AuthContext';

export interface Subscription {
  id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  product_id: string;
  product_name: string;
  pricing_type: '1_2_year' | '3_5_year' | 'lifetime';
  start_date: string;
  end_date: string | null;
  status: 'active' | 'expired' | 'cancelled' | 'pending';
  requests_used: number;
  requests_limit: number;
  payment_id: string | null;
  order_id: string | null;
  created_at: string;
}

export function useSubscriptions() {
  const { user } = useAuthContext();
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSubscriptions = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    setLoading(true);
    const { data, error: fetchError } = await supabase
      .from('subscriptions')
      .select('*')
      .order('created_at', { ascending: false });
    if (fetchError) setError(fetchError.message);
    else setSubscriptions((data ?? []) as Subscription[]);
    setLoading(false);
  }, [user]);

  useEffect(() => { fetchSubscriptions(); }, [fetchSubscriptions]);

  return { subscriptions, loading, error, refetch: fetchSubscriptions };
}
